import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo/switaly_entertraining_logo.png'


const _withScopeId = n => (_pushScopeId("data-v-124135a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "logincontainer" }
const _hoisted_2 = { class: "form" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    width: "300",
    src: _imports_0
  })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, null, -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Username ")
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Password ")
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Login")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Password dimenticata?", -1))

import {
  IonContent,
  IonButton,
  IonLabel,
  IonText,
  IonPage,
  toastController, modalController, getPlatforms, menuController,
} from '@ionic/vue';
import axios from 'axios';
import { ref } from 'vue';
import {ActionPerformed, PushNotifications, PushNotificationSchema, Token} from "@capacitor/push-notifications";
import {Device} from '@capacitor/device';
import {useRouter} from 'vue-router';
import forgotPasswordModal from "@/views/auth/forgotPasswordModal.vue";
import store from '@/store'

// import './login.scss'

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
    const deviceInfo = ref<any>(null)

    menuController.toggle()

    async function getInfo() {
      deviceInfo.value = await Device.getInfo();
    }

    getInfo()

    const localstore = ref<string | null>('')
    localstore.value = localStorage.getItem('accessToken')

    const blankFields = {
      username: null,
      password: null,
    }

    const fields = ref(JSON.parse(JSON.stringify(blankFields)))
    const resetFields = () => {
      fields.value = JSON.parse(JSON.stringify(blankFields))
    }

    const blankErrorFields = {
      username: null,
      password: null,
    }

    const errorFields = ref(JSON.parse(JSON.stringify(blankErrorFields)))
    const resetErrorFields = () => {
      fields.value = JSON.parse(JSON.stringify(blankErrorFields))
    }

    async function openToastOptions(data, color = 'success') {
      const toast = await toastController.create({
        color: color,
        duration: 2000,
        message: data,
      });
      await toast.present();
    }

    const userData = ref(null)
    const pushToken = ref('')

    function getToken() {

      if (!getPlatforms().includes('desktop') && !getPlatforms().includes('mobileweb')) {


        // alert(deviceInfo.value)
        //   if (deviceInfo.value) {
        // Request permission to use push notifications
        // iOS will prompt user and return if they granted permission or not
        // Android will just grant without prompting
        PushNotifications.requestPermissions().then(result => {
          if (result.receive === 'granted') {
            // Register with Apple / Google to receive push via APNS/FCM
            PushNotifications.register();
          } else {
            console.log('non hai il permesso')
            // Show some error
          }
        });

        // On success, we should be able to receive notifications
        PushNotifications.addListener('registration',
            (token: Token) => {
              pushToken.value = token.value
            }
        );


        // Some issue with our setup and push will not work
        PushNotifications.addListener('registrationError',
            (error: any) => {
              // alert('Error on registration: ' + JSON.stringify(error));
            }
        );

        // Show us the notification payload if the app is open on our device
        PushNotifications.addListener('pushNotificationReceived',
            (notification: PushNotificationSchema) => {
              // alert('Push received: ' + JSON.stringify(notification));
              openToastOptions(JSON.stringify(notification.body), 'success')
            }
        );

        // Method called when tapping on a notification
        PushNotifications.addListener('pushNotificationActionPerformed',
            (notification: ActionPerformed) => {
              // alert('Push action performed: ' + JSON.stringify(notification));
            }
        );

      }
      // }
    }

    if (localStorage.getItem('accessToken')) {
      router.replace({path: 'home'})
    }
    getToken()

    const onSubmit = () => {
      console.log(process.env.VUE_APP_APIURL)
      if (fields.value.username != null && fields.value.password != null && fields.value.username != '' && fields.value.password != '') {
        axios.post(`${process.env.VUE_APP_APIURL}auth/user`, {
          username: fields.value.username,
          password: fields.value.password,
          deviceName: deviceInfo.value.name ? deviceInfo.value.name : 'desktop',
          deviceToken: pushToken.value ? pushToken.value : null,
          appVersion: process.env.VUE_APP_VERSION,
        })
            .then(response => {
              userData.value = response.data.data.user

              store.commit('user/setUser', userData.value)

              localStorage.setItem('userData', JSON.stringify(userData.value))
              localStorage.setItem('accessToken', response.data.data.token)
              localStorage.setItem('lastTokenRefresh', String(Date.now()))
              localstore.value = localStorage.getItem('accessToken')
              //salvo il bearer token negli header di axios
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('accessToken');

              openToastOptions('Login effettuato con successo', 'success')
              resetFields()
              resetErrorFields()

              router.replace({name: 'selectclass'})
            })
            .catch(error => {
              if (error.response.data.message) {
                openToastOptions(error.response.data.message, 'danger')
              } else {
                Object.values(error.response.data)
                    .forEach((message: any) => {
                      openToastOptions(message[0], 'danger')
                    })
              }
            })
      } else {
        errorFields.value.username = (fields.value.username == null)
        errorFields.value.password = (fields.value.password == null)
      }
    }

    async function openForgotPasswordModal() {
      const modal = await modalController
          .create({
            component: forgotPasswordModal,
          })
      return modal.present();
    }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), { fullscreen: true }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _hoisted_4,
              _createVNode(_unref(IonLabel), {
                class: _normalizeClass(`login-label ${errorFields.value.username ? 'label-error' : ''}`)
              }, {
                default: _withCtx(() => [
                  _hoisted_5,
                  (errorFields.value.username)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, " obbligatorio "))
                    : _createCommentVNode("", true),
                  _withDirectives(_createElementVNode("input", {
                    class: "login-input",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fields.value.username) = $event)),
                    type: "text"
                  }, null, 512), [
                    [_vModelText, fields.value.username]
                  ])
                ]),
                _: 1
              }, 8, ["class"]),
              _createVNode(_unref(IonLabel), {
                class: _normalizeClass(`login-label ${errorFields.value.password ? 'label-error' : ''}`)
              }, {
                default: _withCtx(() => [
                  _hoisted_7,
                  (errorFields.value.password)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, "obbligatoria"))
                    : _createCommentVNode("", true),
                  _withDirectives(_createElementVNode("input", {
                    class: "login-input",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((fields.value.password) = $event)),
                    type: "password"
                  }, null, 512), [
                    [_vModelText, fields.value.password]
                  ])
                ]),
                _: 1
              }, 8, ["class"]),
              _createVNode(_unref(IonButton), {
                onClick: onSubmit,
                "ion-button": "",
                block: "",
                class: "btn button login-button",
                type: "submit"
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              }),
              _createVNode(_unref(IonText), {
                color: "primary",
                onClick: openForgotPasswordModal
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})